'use client';

import { Container } from '@trwl/layout';
import { Path } from '@trwl/shared/lib/router';
import { FavouriteIcon } from '@trwl/shared/ui/icons/Favourite.icon';
import { MobileNavLink } from '@trwl/widgets/nav/header/components/MobileNavLink';
import css from '@trwl/widgets/nav/header/styles.module.scss';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { HiOutlineUserCircle } from 'react-icons/hi2';
import { PiHouse } from 'react-icons/pi';
import { RiMenuSearchLine } from 'react-icons/ri';
import { TbTag } from 'react-icons/tb';

export const MobileNavigation = () => {
  const pathname = usePathname();

  const activeTab = useMemo(() => {
    if (pathname === Path.HOME) return 'HOME';
    if (pathname.startsWith(Path.FAVORITES)) return 'FAVORITES';
    if (pathname.startsWith(Path.BRANDS)) return 'BRANDS';
    if (pathname.startsWith(Path.USER)) return 'USER';
    if (pathname.startsWith(Path.CATALOG) || pathname.startsWith(Path.PRODUCT))
      return 'CATALOG';
  }, [pathname]);

  return (
    <nav className={css.mobileNavigationBar}>
      <Container>
        <div
          className={
            'grid grid-cols-5 w-full h-full justify-between items-center gap-4'
          }
        >
          <MobileNavLink
            active={activeTab === 'HOME'}
            linkProps={{ href: Path.HOME }}
            title={'Главная'}
            icon={<PiHouse className="w-[22px] h-[22px]" />}
          />
          <MobileNavLink
            active={activeTab === 'CATALOG'}
            linkProps={{ href: Path.CATALOG }}
            title={'Поиск'}
            icon={<RiMenuSearchLine className="w-[22px] h-[22px]" />}
          />
          <MobileNavLink
            active={activeTab === 'BRANDS'}
            title={'Бренды'}
            linkProps={{ href: Path.BRANDS }}
            icon={<TbTag className="w-[22px] h-[22px] rotate-90" />}
          />
          <MobileNavLink
            active={activeTab === 'FAVORITES'}
            linkProps={{ href: Path.FAVORITES }}
            title={'Вишлист'}
            icon={<FavouriteIcon className="w-[22px] h-[22px]" />}
          />
          <MobileNavLink
            active={activeTab === 'USER'}
            linkProps={{ href: Path.PROFILE }}
            title={'Профиль'}
            icon={<HiOutlineUserCircle className="w-[22px] h-[22px]" />}
          />
        </div>
      </Container>
    </nav>
  );
};
